import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import lang from '@blade/common/pages/alarm-center-dialog/lang/index';
import moment from 'moment';
import { AlarmDetailsModule } from '@blade/common/store/alarm-details';
import { resolveOfBigBatch } from '@blade/common/api/alarm-center';
import { AlarmCenterModule } from '@blade-sxp/alarm-center/store/index';
import { debounce } from 'lodash';
let CrowdReport = class CrowdReport extends Vue {
    detailId;
    isDelete;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    activeIdx = '';
    activeId = '';
    isSolveAll = false;
    isIgnoreAll = false;
    get portraitId() {
        return this.$route.query.portraitId;
    }
    pagination = {
        page: 1,
        size: 100,
        total: 0,
    };
    lists = [];
    activeDetail = null;
    noIncidentStatusArr = [];
    curIncidentArr = []; // 解决或忽略的id
    curListIdx = 0;
    newReqParam = {};
    alarNOChange = [];
    solveAllDebounced = debounce(this.solveAll, 500, { trailing: true });
    ignoreAllDebounced = debounce(this.ignoreAll, 500, { trailing: true });
    isTaskType = [
        'INCIDENT_PEDESTRIAN_ATTRIBUTE_UNMATCHED',
        'INCIDENT_FACE_UNMATCHED',
        'INCIDENT_AUTOMOBILE_LICENSE_PLATE_UNMATCHED',
        'INCIDENT_AUTOMOBILE_ATTRIBUTE_UNMATCHED',
    ]; // 人体未比中 人脸未比中 车牌未比中 车辆属性未比中
    // 转换后数组
    onFirstList(val) {
        if (val) {
            this.lists = val;
            if (!this.activeIdx || this.isDelete) {
                this.activeIdx = val?.[0]?.lists?.[0]?.id ?? '';
            }
            else {
                let hasActive = false;
                this.lists.forEach((it) => {
                    it.lists.forEach((em) => {
                        if (em.id === this.activeIdx) {
                            hasActive = true;
                            AlarmDetailsModule.updateDetailsData(em);
                        }
                    });
                });
                if (!hasActive) {
                    this.activeIdx = val?.[0]?.lists?.[0]?.id ?? '';
                }
            }
        }
    }
    get firstList() {
        return AlarmDetailsModule.alarConList;
    }
    // 请求参数
    onReqParam(val) {
        if (val) {
            this.newReqParam = val;
        }
    }
    get reqParam() {
        return AlarmDetailsModule.paramTaskIds;
    }
    // 转换前得数组
    onOldList(val) {
        if (val) {
            this.noIncidentStatusArr = val;
            this.alarNOChange = val;
        }
    }
    get oldList() {
        return AlarmDetailsModule.alarNOChange;
    }
    get total() {
        return AlarmDetailsModule.total;
    }
    get details() {
        return AlarmDetailsModule.detailsData;
    }
    mounted() { }
    resolveAlarmList(status) {
        if (status === 'VERIFIED') {
            this.isIgnoreAll = false;
            this.isSolveAll = true;
        }
        else if (status === 'NO_REPORT') {
            this.isIgnoreAll = true;
            this.isSolveAll = false;
        }
        //   // 对应的任务才传任务类型 其余不传
        const incidentTypes = this.isTaskType.includes(this.newReqParam.incidentTypes?.[0])
            ? this.newReqParam.incidentTypes
            : [];
        const reqParam = {
            ...AlarmCenterModule.searchdata,
            batchOperateRecord: {
                resolveStatus: status,
            },
            portraitId: this.newReqParam.portraitId || null,
            recordIds: null,
            dateEnd: this.newReqParam.dateEnd,
            dateStart: this.newReqParam.dateStart,
            taskIds: this.newReqParam.taskIds,
            deviceIds: this.newReqParam.deviceIds,
            foldedKey: this.newReqParam.foldedKey,
            incidentTypes: incidentTypes,
            page: 1,
        };
        resolveOfBigBatch({ ...reqParam }).then((res) => {
            this.activeIdx = '';
            this.$emit('getDataAgain');
            this.$message({
                customClass: 'sub-message',
                message: res,
                type: 'success',
            });
        });
    }
    async viewMore() {
        this.pagination.page += 1;
        this.newReqParam.page = this.pagination.page;
        const list = await AlarmDetailsModule.getAlarmListFun(this.newReqParam);
        this.alarNOChange = this.alarNOChange.concat(list.list);
        AlarmDetailsModule.updatAalarNOChange(this.alarNOChange);
        this.initTimeData(this.alarNOChange);
        this.isSolveAll = false;
        this.isIgnoreAll = false;
    }
    getKeyValue(object, arg) {
        return object[arg];
    }
    initTimeData(data) {
        let timeaArr = [];
        const b = data.reduce((prev, cur) => {
            if (!prev[this.timeDateFormat(cur.alertTime)]) {
                prev[this.timeDateFormat(cur.alertTime)] = [];
            }
            if (cur.alertTime) {
                prev[this.timeDateFormat(cur.alertTime)].push(cur);
            }
            return prev;
        }, {});
        for (let i in b) {
            timeaArr.push({
                timeTitle: i,
                lists: b[i],
            });
        }
        this.lists = timeaArr;
    }
    timeDateFormat(time) {
        return moment(Number(time)).format('MMM-DD');
    }
    lintTime(time) {
        return moment(Number(time)).format('HH:mm');
    }
    lintTimeSs(time) {
        return moment(Number(time)).format('HH:mm:ss');
    }
    changeData(it) {
        this.activeIdx = it.id;
        this.activeDetail = it;
        AlarmDetailsModule.updateDetailsData(it);
    }
    showImg(it) {
        this.activeId = it.id;
    }
    hideImg() {
        this.activeId = '';
    }
    solveAll() {
        if (this.isSolveAll)
            return;
        this.resolveAlarmList('VERIFIED');
    }
    ignoreAll() {
        if (this.isIgnoreAll)
            return;
        this.resolveAlarmList('NO_REPORT');
    }
};
__decorate([
    Prop()
], CrowdReport.prototype, "detailId", void 0);
__decorate([
    Prop()
], CrowdReport.prototype, "isDelete", void 0);
__decorate([
    Watch('firstList', { immediate: true })
], CrowdReport.prototype, "onFirstList", null);
__decorate([
    Watch('reqParam', { deep: true, immediate: true })
], CrowdReport.prototype, "onReqParam", null);
__decorate([
    Watch('oldList', { deep: true, immediate: true })
], CrowdReport.prototype, "onOldList", null);
CrowdReport = __decorate([
    Component({
        name: 'alarmTimeLine',
        components: {},
        i18n: {
            messages: lang,
        },
    })
], CrowdReport);
export default CrowdReport;
